

import { Vue, Component, Prop, Ref, Emit } from 'vue-property-decorator'

@Component
export default class HonjoTabs extends Vue {
  @Prop([String, Number]) value!: string | number

  @Emit() input (value: string | number) {}

  get activeValue () {
    return this.value
  }

  set activeValue (value: string | number) {
    this.input(value)
  }
}
